var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconBrokenCel = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.9628 47.9988C35.1848 47.9988 37.7955 45.3415 37.7955 42.0646V5.93419C37.7955 2.65732 35.1848 0 31.9628 0H16.0356C12.8137 0 10.2041 2.65732 10.2041 5.93419V42.0658C10.2041 45.3427 12.8137 48 16.0356 48L31.9628 47.9988ZM24.0016 44.8616C22.4318 44.8616 21.1605 43.5914 21.1605 42.024C21.1605 40.4566 22.4318 39.1876 24.0016 39.1876C25.5678 39.1876 26.838 40.4566 26.838 42.024C26.838 43.5914 25.5678 44.8616 24.0016 44.8616ZM13.7997 34.4221V8.98068C13.7997 7.66157 14.8681 6.59315 16.1872 6.59315H31.8124C33.1315 6.59315 34.1999 7.66157 34.1999 8.97948C34.1999 14.6296 34.1999 28.7697 34.1999 34.421C34.1999 35.7401 33.1315 36.8085 31.8124 36.8085H16.1872C14.8681 36.8097 13.7997 35.7413 13.7997 34.4221Z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 8.70508,
  y: 15.3682,
  width: 33.0149,
  height: 5.69819,
  transform: "rotate(15 8.70508 15.3682)",
  fill: "#f5f5f5",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.9989 33.8484L26.6808 26.1315C26.9959 25.8164 26.7708 25.2788 26.3257 25.2788H25.713C25.2955 25.2788 25.0604 24.7961 25.3205 24.4686L29.394 19.3323C29.654 19.0047 29.4215 18.5221 29.0014 18.5221H26.9534C26.5408 18.5221 26.3057 18.052 26.5533 17.7219L31.757 10.8002C32.0046 10.4701 31.7695 10 31.3569 10H23.1274C22.9373 10 22.7623 10.1075 22.6798 10.2776L18.6563 18.4171C18.4912 18.7497 18.7338 19.1398 19.1039 19.1398H20.9593C21.3294 19.1398 21.572 19.5299 21.407 19.8625L18.6563 25.4289C18.4912 25.7615 18.7338 26.1515 19.1039 26.1515H20.8518C21.2219 26.1515 21.4619 26.5366 21.3019 26.8692L18.1962 33.2783C17.9486 33.7859 18.6013 34.2485 18.9989 33.8484Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "white"
})))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBrokenCel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_broken_cel.d92c5626.svg";
export { ForwardRef as ReactComponent };